/**
 * Traffic ECS components (M4 spec §10.2, plan I4): bitECS 0.4 structure-of-arrays stores with `MAX_ENTITIES`
 * slots, like src/reach/components.ts. A real traffic ship carries both: `Agent` maps the ECS ship to its local
 * agent record (the contact store slot, `contacts.ts`), `TrafficPilot` is the traffic pilot's state
 * (`src/ai/traffic.ts`). Add them with `addComponent(sim.world, eid, Agent)`; write the slots directly.
 * No edit to src/world/components.ts.
 */
import { MAX_ENTITIES } from '../world/components'

/** The local agent a real traffic ship flies for: its slot in the contact store. */
export const Agent = { index: new Int32Array(MAX_ENTITIES) }

/**
 * The traffic pilot (spec §10.3): `phase` is a `TRAFFIC_PHASE` code, (tx, ty, tz) the float64 world point the
 * phase steers for, `speedCap` the phase's speed limit (m/s), `timer` seconds in the phase.
 */
export const TrafficPilot = {
  phase: new Uint8Array(MAX_ENTITIES),
  tx: new Float64Array(MAX_ENTITIES),
  ty: new Float64Array(MAX_ENTITIES),
  tz: new Float64Array(MAX_ENTITIES),
  speedCap: new Float32Array(MAX_ENTITIES),
  timer: new Float32Array(MAX_ENTITIES),
}

/**
 * Traffic pilot phases (spec §10.3). `cruise` is the hand-back: the pilot sets it when the ship is clear of every
 * station on a leg, and the tier step (`realShips.ts`) demotes the ship to a contact. `done` is set when the step
 * ended for the real ship (docked inside the station): the tier step despawns it and the step is reported.
 */
export const TRAFFIC_PHASE = { undock: 0, sublight: 1, cruise: 2, dock: 3, mine: 4, hold: 5, done: 6 } as const
export type TrafficPhase = (typeof TRAFFIC_PHASE)[keyof typeof TRAFFIC_PHASE]
